import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './daily_price_report.routes';
import ActivePowerService from '../../../components/api/active_power/active_power.service';
import WeatherService from '../../../components/api/weather/weather.service';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import MathUtil from '../../../components/logic/math_util/math_util';
import chartConfig from './daily_price_report.config';

export class DailyPriceReportController {
  /*@ngInject*/
  constructor($stateParams, moment, $interval, $filter, $q, ActivePowerService, DateUtil, MathUtil, WeatherService, CompareWeatherLogic) {
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
    this.interval = $interval;
    this.filter = $filter;
    this.$q = $q;
    const self = this;
    this.moment = moment;

    this.categories = DateUtil.getXLabels; // ['00:30', '01:00', ... '00:00']
    this.id = $stateParams.id;
    this.targetDate = this.moment().startOf('day').toDate();
    this.minDate = this.moment().startOf('day').subtract(7, 'days').toDate();
    this.maxDate = this.targetDate;
    this.missingTimes = [];
    this.noCalculateTimes = [];

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      this.baseUnitPrice = config.base_unit_price;
      this.powerUnitPrice = config.power_unit_price;
      this.contractPower = config.contract_power;

      this.updateGraph(this.targetDate);
    });

    this.timer = this.interval(() => {
      this.updateGraph(this.targetDate);
    }, 300000);
  }

  changeDate(diff) {
    if (diff !== undefined) {
      this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
    }

    this.updateGraph(this.targetDate);
  }

  updateGraph(targetDate) {
    const powerQuery = angular.extend({id: this.id}, this.DateUtil.getActivePowerQueries(targetDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getQueryParams(targetDate));

    this.$q.all([
      this.ActivePowerService.show(powerQuery).$promise,
      this.WeatherService.api.index(weatherQuery).$promise
    ]).then(responses => {
      this.powerPrices = this.formatToPrices(responses[0].powers);

      if (!this.chart) { return; }

      this.weathers = this.formatWeather(responses[1]);
      this.series.setData(this.powerPrices);
      this.chart.reflow();
    });

    this.ActivePowerService.show(
      angular.extend({id: this.id}, this.DateUtil.getActivePowerQueries(targetDate)),
      response => {
        this.powerPrices = this.formatToPrices(response.powers);

        if (this.chart) {
          this.series.setData(this.powerPrices);
          this.chart.reflow();
        }
      }
    );
  }

  formatToPrices(activePowers) {
    this.missingTimes = [];
    this.noCalculateTimes = [];
    let sumPower = 0;

    if (activePowers.length === 0) {
      return [];
    }

    //先頭データの時刻と 00:00 を比較してデータの抜け数を計算
    let firstMeasuredAt = this.moment(activePowers[0].measured_at);
    let beginningTime = this.moment(this.targetDate).startOf('day');
    let shift_range = firstMeasuredAt.diff(beginningTime, 'minutes') / 30;

    let formated_powers = [];

    activePowers.forEach((activePower, index) => {
      if (!activePowers[index - 1]) {
        return;
      }
      // 例：10:00 のデータが欠損していた場合
      // 10:00 に「データなし」を表示する
      // 10:30 に「差分計算不可」を表示する
      if (activePower.missing) {
        this.missingTimes.push(this.categories[index + shift_range - 1]);
        formated_powers.push(0);
      } else if (activePowers[index - 1].missing) {
        this.noCalculateTimes.push(this.categories[index + shift_range - 1]);
        formated_powers.push(0);
      } else {
        let power = this.MathUtil.subtract(activePowers[index].value, activePowers[index - 1].value);
        sumPower += power;
        formated_powers.push(this.calcPowerPrice(power));
      }
    });

    //先頭のデータが存在しなかった場合、グラフ全体を後ろにずらす。
    for (let i = 0; i < shift_range; i++) {
      formated_powers.unshift(null);
    }

    this.powerPrice = this.calcPowerPrice(sumPower);
    this.basePrice = this.calcBasePrice();

    return formated_powers;
  }

  isMissingTime(time) {
    return this.missingTimes.indexOf(time) !== -1
  }

  isNoCalculateTime(time) {
    return this.noCalculateTimes.indexOf(time) !== -1
  }

  calcPowerPrice(power) {
    return this.powerUnitPrice * power;
  }

  calcBasePrice() {
    return this.contractPower * this.baseUnitPrice;
  }

  $onDestroy() {
    if (this.timer) {
      this.interval.cancel(this.timer);
    }
  }

  formatWeather(weathers) {
    const weatherSamplingInterval = ['03:00', '09:00', '15:00', '21:00'];

    const formattedWeathers = this.CompareWeatherLogic.compareHourly(weathers, weatherSamplingInterval);
    const y = formattedWeathers.length > 0 ? 46 : null;

    this.chart.xAxis[0].update({
      labels: {y: y}
    }, false);

    this.chart.reflow();

    return formattedWeathers;
  }
}

export default angular.module('leptonApp.dailyPriceReport', [uiRouter, moment, DateUtil, MathUtil, ActivePowerService, WeatherService, CompareWeatherLogic])
  .config(routing)
  .component('dailyPriceReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./daily_price_report.html'),
    controller: DailyPriceReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/price_report/daily/daily_price_report.component.js